import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $isListItemNode } from '@lexical/list';
import {
  $getSelection,
  $isRangeSelection,
  INDENT_CONTENT_COMMAND,
  COMMAND_PRIORITY_HIGH,
} from 'lexical';
import { useEffect } from 'react';

interface ListMaxIndentLevelPluginProps {
  maxDepth: number;
}

export function ListMaxIndentLevelPlugin({
  maxDepth,
}: ListMaxIndentLevelPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INDENT_CONTENT_COMMAND,
      () => {
        const selection = $getSelection();
        if (!$isRangeSelection(selection)) {
          return false;
        }

        const nodes = selection.getNodes();
        for (const node of nodes) {
          if ($isListItemNode(node)) {
            const listDepth = node.getIndent();
            if (listDepth >= maxDepth) {
              return true; // Prevent further indentation
            }
          }
        }

        return false; // Allow normal indentation
      },
      COMMAND_PRIORITY_HIGH,
    );
  }, [editor, maxDepth]);

  return null;
}
